import { COMPANY_ROLES } from '@/constants/roles'
import { ROLE_RENTER, type UserData } from '@/types/auth'
import type { AboutContentResponse } from '../types/help'

/**
 * Angular `authService.getSelectedCurrentUserRole()` — reads `current_role` from
 * persisted `localStorage.user` when Redux has not hydrated yet.
 */
export function getCurrentRoleNameForHelp(
  user: UserData | null | undefined,
): string {
  if (user?.current_role?.role_name) {
    return user.current_role.role_name
  }

  try {
    const raw = localStorage.getItem('user')
    if (!raw) return ''
    const stored = JSON.parse(raw) as UserData
    return stored.current_role?.role_name ?? ''
  } catch {
    return ''
  }
}

/** Whether persisted user JSON exists (Angular localStorage parity on refresh). */
export function hasStoredUserRecord(): boolean {
  try {
    return localStorage.getItem('user') !== null
  } catch {
    return false
  }
}

/**
 * Pick CMS HTML field — mirrors `help-about.component.ts` getPageContent().
 * No fallback between variants (Angular uses the selected field as-is).
 */
export function resolveHelpAboutContent(
  response: AboutContentResponse,
  roleName: string,
): string | null | undefined {
  if (roleName === ROLE_RENTER) {
    return response.about_content_applicant
  }
  if ((COMPANY_ROLES as readonly string[]).includes(roleName)) {
    return response.about_content_pmc
  }
  return response.about_content
}
